
/**
 * Create a way to handle multiple events under one handler
 * @param {Function} handler This is the handler that will get fired
 * after all events are triggered
 * @returns {Function} Returns a method for creating an event handler. Everytime
 * this is fired it adds a handler to the group.
 */
function createEventSync(handler){

  // Ends up in the format after three synced events fire
  // [
  //   [[...args]],
  //   [[...args]],
  //   [[...args]],
  // ]
  // After we have a solid column like above, the first column
  // will be removed to prevent an ever increasing array size
  // If it ever ends up in this format you know the events aren't
  // in sync anymore and will throw an error
  // [
  //   []
  //   [[...args],[...args]]
  //   [[...args]]
  // ]
  var eventTally = []

  var index = 0
  var createEventHandler = function(){
    eventTally[index] = []
    var localIndex = index
    index++
    return function genericEventHandler(...args){
      eventTally[localIndex].push(args)
      checkAndFireHandler()
    }
  }

  function checkAndFireHandler(){
    // Sanity check
    var goodToGo = eventTally.every(arr => {
      if (arr.length > 1)
        throw new Error('Events are out of sync.')
      return arr.length == 1
    })
    if (!goodToGo) return
    var results = []
    for (var i = 0; i < eventTally.length; i++){
      var container = eventTally[i]
      results.push(container.pop())
    }
    handler(...results)
  }

  return createEventHandler
}

export default createEventSync


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/lib/createEventSync.js